<template>
    <div class="v-home" :key="$root.render_keys.home">
        <div class="s-pages">
            <section class="s-recap s-page" id="recap">
               <HomeRecap />
            </section>
            <section class="s-hero s-page pp-scrollable" id="video">
                <HomeHero />             
            </section>
            <section class="s-recap s-page" id="social">
                <HomeSocial />
            </section>
            <section class="s-recap s-page" id="celebration">
                <HomeCelebrate />
            </section>
            <section class="s-recap s-page" id="hype">
                <HomeHype />
            </section>
            <section class="s-awards s-page" id="awards">
                <HomeAwards />
            </section>
        </div>

        <button class="s-pages-button" v-on:click="next_section">Down</button>
        <div v-if="$mq != 'sm'" class="v-home__logo"><a href="#recap"><img src="@/assets/nc_logo.png" alt="National Champions" /></a></div>
        <div class="v-home__icons">
            <a href=" https://lsusports.net/sports/2019/10/28/2020-football-season-ticket-interest-form.aspx"><img class="v-home__icon v-home__icon--tickets" src="@/assets/ticket_icon.svg" alt="Tickets"/></a>
            <a href="https://www.lsushop.net/?_s=bm-national_champions_splash_page&utm_medium=referral&utm_term=national_champions_embedded"><img class="v-home__icon v-home__icon--gear" src="@/assets/gear_icon.svg" alt="Gear"/></a>
        </div>
        <button class="v-home__menu-button" @click="menu_open = !menu_open" :class="{'is-open': menu_open}" aria-label="toggle menu">
            <span class="v-home__menu-line-a"></span>
            <span class="v-home__menu-line-b"></span>
        </button>
        <div class="v-home__menu-offcanvas" :class="{'is-open': menu_open}">
            <ul id="scrollMenu" class="v-home__menu-nav">
                 <li v-for="(item,index) in nav_items" :key="index" class="v-home__menu-nav-item" data-menuanchor="item.section"><a @click="menu_open = false" class="v-home__menu-nav-link" :href="'#' + item.section">{{ item.title }}</a></li>
                <li class="v-home__menu-nav-logo-item"><a href="https://lsusports.net"><img class="v-home__menu-nav-logo" src="@/assets/LSUsportsnet.svg" alt="Go to LSUsports.net"/></a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import HomeHero from '@/components/HomeHero.vue'
    import HomeRecap from '@/components/HomeRecap.vue'
    import HomeSocial from '@/components/HomeSocial.vue'
    import HomeCelebrate from '@/components/HomeCelebrate.vue'
    import HomeHype from '@/components/HomeHype.vue'
    import HomeAwards from '@/components/HomeAwards.vue'
    import jQuery from 'jquery'
    import pagepiling from 'pagepiling.js'
    import _ from 'lodash';
    import '../../node_modules/pagepiling.js/dist/jquery.pagepiling.min.css'

    let $ = jQuery;
    
    export default {
        name: "home",

        components: {
            HomeRecap,
            HomeHero,
            HomeSocial,
            HomeCelebrate,
            HomeHype,
            HomeAwards
        },

        data: () => ({
            current_section: 0,
            previous_window_width: window.innerWidth,
            section_positions: [],
            menu_open:false,
            nav_items:[
                {title:'The Game. The Recap.', section:'recap'},
                {title:'One Team. One Heartbeat.', section:'video'},
                {title:'#GeauxTigers', section:'social'},
                {title:'Celebrate. And Party.', section:'celebration'},
                {title:'Beyond Hype.', section:'hype'},
                {title:'Difference Makers.', section:'awards'}
            ]
        }),


        methods: {
            get_current_section(nextIndex) {
                
                let current_section = nextIndex - 1;

                if (current_section >= 2 ) {
                    current_section =  current_section - 1;
                }

                this.current_section = current_section;
            },    
            init_pagepile() {
                if (window.matchMedia("(min-width: 960px)").matches) {
                    this.$nextTick(() => {
                        let sections = document.querySelectorAll('.s-page');

                        for (let i = 0; i < sections.length; i++) {
                            sections[i].classList.add('pp-scrollable');
                        }

                        this.pagepile('.s-pages');
                    })

                } else {                    
                    let sections = document.querySelectorAll('.s-page');
                    
                    for (let i = 0; i < sections.length; i++) {
                        sections[i].classList.remove('pp-scrollable');
                    }                    
                }
            },
            pagepile(el) {
                let anchors = []
                 _.forEach(this.nav_items, function(value){anchors.push( value.section);});

                let $video = $('.c-hero-bg video').get(0);

                $(el).pagepiling({
                    direction: 'vertical',
                    easing: 'swing',
                    navigation: false,
                    scrollingSpeed: 250,
                    sectionSelector: '.s-page',
                    anchors:anchors,
                    menu:'#scrollMenu',
                    onLeave(index, nextIndex, direction){
                        if(nextIndex == 6){
                            $('.s-pages-button').addClass('is-end');
                        }else{
                            $('.s-pages-button').removeClass('is-end');
                        }
                    },
                    afterLoad:function(anchor,index){
                        if(anchor == 'video'){
                            $video.play();
                        }else{
                            $video.pause();
                        }
                    }
                });
            },
            next_section(){
                if(window.innerWidth < 960 ){
                    let sections = document.querySelectorAll('.s-page');
                    for (let i = 0; i < sections.length; i++) {
                        if(window.scrollY < sections[i].offsetTop - 10){
                            sections[i].scrollIntoView({behavior:'smooth'});
                            break;
                        }
                    }
                }else{
                $.fn.pagepiling.moveSectionDown();
                }
            }
        },

        mounted() {
            this.$root.render_keys.home = Date.now();            
            window.addEventListener('resize', () => {
                if (
                    (this.previous_window_width < 960 && window.innerWidth >= 960)
                    || (this.previous_window_width >= 960 && window.innerWidth < 960)
                ) {
                    this.$root.render_keys.home = Date.now();
                }

                this.previous_window_width = window.innerWidth;
            });

            function has_hit_bottom(){
                 if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 150) {
                      $('.s-pages-button').addClass('is-end');
                 }else{
                      $('.s-pages-button').removeClass('is-end');
                 }
            }

            window.addEventListener('scroll', _.throttle(has_hit_bottom, 100));                   
        },

        watch: {            
            '$root.render_keys.home'(newVal, oldVal) {
                this.init_pagepile();
            }
        }
    };
</script>

<style lang="scss">
@import "../styles/imports";
html, body{
    overflow:visible !important;
}

@media all and (min-width:$small-breakpoint){
    html, body{
        overflow:hidden !important;
    }
}
</style>

<style lang="scss" scoped>
    @import "../styles/imports";

    @keyframes bounce{ 
        from{
            bottom:24px;

        }

        10%{
            bottom:24px;
        }

        25%{
            bottom:36px;
        }

        40%{
            bottom:24px;
        }

        55%{
            bottom:36px;
        }

        70%{
            bottom:24px;
        }
        to{
            bottom:24px;
        }
    }

    .s-pages-button{
        @include appearance;
        font-size: 0;
        width:48px;
        height:48px;
        position: fixed;
        bottom:24px;
        right:12px;
        outline:none;
        
        z-index: 99;
        cursor:pointer;
        opacity:1;
        transition:opacity 0.4s;
        &::after{
            position: absolute;
            animation:bounce 2s infinite;
            left:50%;
            font-family: 'feather';
            content:'\e842';
            pointer-events:none;
            font-size: 36px;
            color:$white;
            @include transform(translate(-50%,50%));
        }
        &:hover{
            &::after{
                color:$gold;
                animation-play-state:paused;
            }
        }
        &.is-end{ 
            opacity:0;
            pointer-events:none;
        }
    }

    .s-pages{
        min-height:100vh;
        ::-webkit-scrollbar {
            width: 0px;  /* remove scrollbar space */
            background: transparent;  /* optional: just make scrollbar invisible */
        }
        -ms-overflow-style: none;
    }

    .s-page {
        background:url('../assets/scratch_bkg.jpg') center center no-repeat; 
        background-size:cover;
        background-color:#333;
        width:100%;   
        padding-bottom:80px; 
        overflow-x:hidden;
        position:relative;
        &.s-hero, &.s-awards{ padding-bottom:0;}
        &::before{
            position:absolute;
            top:25%;
            left:0;
            width:25%;
            height:25%;
            content:'';
            pointer-events:none;
            z-index:1;
            background:url('../assets/dots.png') top right repeat;
        }
    }
    .v-home{
        &__logo{
            position: fixed;
            top:48px;
            left:50%;
            @include transform(translate(-50%,0));
            height: calc((100vw * 0.6 * 0.33333 * 0.5625) - 48px);
            min-height:80px;
            max-height:120px;
            z-index: 99;
            img{
                max-height:100%;
                width:auto;
            }
        }
        &__icons{
            position:fixed;
            top: 22px;
            z-index:99;
            right:22px;
            &::before{
                position:absolute;
                top:-22px;
                right:-22px;
                height:100px;
                width:100vw;
                content:'';
                background: linear-gradient(180deg, rgba(0,0,0,0.8603816526610644) 0%, rgba(0,0,0,0.7987570028011204) 65%, rgba(0,0,0,0) 100%);
                pointer-events:none;
            }
            a{
                display:inline-block;
                position: relative;
                &::before{
                    position:absolute;
                    bottom:0;
                    left:50%;
                    width:40px;
                    height:4px;
                    content:'';
                    opacity:0;
                    box-shadow: 0px 0px 4px 3px rgba($gold,1);
                    @include transform(translate(-50%,16px));
                    transition:opacity 0.3s;
                    pointer-events:none;
                }
                &:hover{
                    &::before{
                        opacity:1;
                        
                    }
                }
                &:last-child{
                    margin-left:33px;
                }
            }
        }
        &__icon{
            height:44px;
            position:relative;
            
            &--tickets{
                @include transform(rotate(30deg));
            }
        }
        &__menu-button{
            @include appearance;
            position:fixed;
            top:2px;
            left:0;
            width:96px;
            height:48px;
            overflow: visible;
            z-index: 401;
            &:focus{
                outline:none;
            }
            &:hover{
                cursor: pointer;
                .v-home__menu-line-a, .v-home__menu-line-b{
                    box-shadow: 0px 0px 3px 1px rgba($gold,1);
                }
            }

            &.is-open{
                .v-home__menu-line-a{
                    width:36px;
                    border-radius:2px;
                    @include transform(rotate(45deg));
                    left:24px;
                }
                .v-home__menu-line-b{
                    width:36px;
                    left:24px;
                    top:24px;
                    border-radius:2px;
                    @include transform(rotate(-45deg));
                }
            }        
        }
        &__menu-line-a{
            position:absolute;
            top:24px;
            left:0;
            width:96px;
            height:2px;
            background:$gold;
            transition:0.3s;
        }
        &__menu-line-b{
            position:absolute;
            top:38px;
            left:0;
            width:68px;
            height:2px;
            background:$gold;
            transition:0.3s;
        }
        &__menu-offcanvas{
            position:fixed;
            top:0;
            left:-9999px;
            width:100%;
            height:100%;
            background:rgba(0,0,0,0.95);
            z-index: 400;
            overflow:auto;
            opacity:0;
            @include flex-container;
            @include justify-center;
            transition: opacity 0.3s 0s, left 0s 0.3s;
            &.is-open{
                left:0;
                opacity:1;
                transition: opacity 0.3s 0s, left 0s 0s;
            }
        }
        &__menu-nav{
            margin:0 auto;
            @include reset-list;
            @include inline-flex;
            @include flex-column;
            @include align-stretch;
            min-height:100%;
            @include justify-center;
            text-align: center;
        }
        &__menu-nav-logo-item{
            padding-bottom:24px;
        }
        &__menu-nav-link{
            padding:16px 48px;
            display: inline-block;
            text-decoration:none;
            color: $white;
            text-transform: uppercase;
            letter-spacing: 0.25rem;
            font-weight:700;
            font-size: 1.125rem;
            transition:0.2s;
            width:100%;
            position:relative;
        }
        &__menu-nav-logo{
            width:120px;
        }
    }

    .c-home{
        position:relative;
        min-height:100vh;
    }
    .c-home--has-grid{
        padding-top:100px;
    }

    @media all and (min-width:$small-breakpoint){
        .s-pages-button{
            right:auto;
            left:50%;
            transform:translate(-50%,0);
        }
        .s-page{
            padding-bottom:0;
            position:absolute;
             &::before, &::after{
                position:absolute;
                top:50%;
                left:0;
                width:299px;
                height:100%;
                background:url('../assets/spray_left.png') center left no-repeat;
                pointer-events: none;   
                @include transform(translateY(-50%));   
                content:'';      
                z-index: 1;
            }
            &::after{
                left:auto;
                right:0;
                background:url('../assets/spray_right.png') center right no-repeat;
            }
        }
        .c-home--has-grid{
         padding-top:calc(100vw * 0.6 * 0.33333 * 0.5625);

        }
        .v-home{
            &__menu-button{
                top:24px;
                &.is-open{
                    .v-home__menu-line-a, .v-home__menu-line-b{
                        left:24px;
                    }
                }
            }
            &__icons{
                right:42px;
                top:42px;
                &::before{
                    display:none;
                }
                a{
                    &:last-child{
                        margin-left:48px;
                    }
                }
            }
            &__icon{
                height:55px;
                &--gear{
                   
                }
            }
            &__menu-nav-link{
                font-size:1.5rem;
                letter-spacing:0.5rem;
                padding:30px 52px;
                &::before{
                    position:absolute;
                    top:50%;
                    left:0;
                    width:40px;
                    height:40px;
                    content:'';
                    @include transform(translateY(-50%));
                    background:url('../assets/fleur.svg') center center no-repeat;
                    background-size:contain;
                    opacity:0;

                }
                &:hover{
                    color: $gold;
                    &::before{
                        opacity:1;
                        transition:opacity 0.2s;
                    }
                }
            }
        }
    }
</style>